import { render, staticRenderFns } from "./inventaire-produits-table.html?vue&type=template&id=cff94092&scoped=true&external"
import script from "./inventaire-produits-table.js?vue&type=script&lang=js&external"
export * from "./inventaire-produits-table.js?vue&type=script&lang=js&external"
import style0 from "./inventaire-produits-table.scss?vue&type=style&index=0&id=cff94092&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff94092",
  null
  
)

export default component.exports